import React from 'react';
import Flinks from '../../FlinksConnect';

export default function FlinksServiceProvider(props) {
  return (
    <Flinks
      clientId={props.scoringRequest.clientId}
      requestId={props.scoringRequest.requestId}
      skipBankingSurvey={props.skipBankingSurvey}
      createScoringRequest={props.createScoringRequest}
      onNextStep={props.proceedToNext}
      bankId={props.dataProvider.id}
      showBackButton={props.showBackButton}
      webhookData={props.webhookData}
      isSmartSelect
    />
  );
}
